module.exports = __webpack_public_path__ + "static/29-39565fae1a7f2e9ce4ec26994c36670b.png";